import { ArticleParagraph1, ArticleParagraph2, IconInformation16, Image, Tooltip } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { clsx } from 'clsx';
import { FC } from 'react';

import { EBookCoworkingFormFields } from 'shared/components/BookCoworkingFrom/constants';
import { BookCoworkingModal } from 'shared/components/BookCoworkingModal';
import { ButtonWithAnalyticEvent } from 'shared/containers/ButtonWithAnalyticEvent';
import { trackBookingButtonClick } from 'shared/store/analytics/actions/trackBookingButtonClick';

import { getPlaceGaObjectType } from './internal/helpers/getPlaceGaObjectType';
import { getPlaceLabel } from './internal/helpers/getPlaceLabel';
import { getPlaceModalType } from './internal/helpers/getPlaceModalType';
import { getPlaceTooltipText } from './internal/helpers/getPlaceTooltipText';
import { IPlaceProps } from './types';

import styles from './styles.css';

export const Place: FC<IPlaceProps> = props => {
  const { className, price, count, type, fullUrl, photos, id } = props;

  if (!count || !price) {
    return null;
  }

  const firstPhoto = photos[0];

  return (
    <div className={clsx(styles['root'], className)}>
      <div className={styles['overlay']} />
      <div className={styles['border']}>
        {firstPhoto && (
          <div className={styles['image']}>
            <Image alt={`flex_office_${id}`} height={56} src={firstPhoto.mini} width={56} />
          </div>
        )}
        <a className={styles['title']} href={fullUrl} rel="noreferrer" target="_blank">
          <ArticleParagraph1 color="primary_100" fontWeight="bold">
            {getPlaceLabel(type, count)}
          </ArticleParagraph1>
          <span className={styles['tooltip']}>
            <Tooltip title={<div className={styles['tooltip-body']}>{getPlaceTooltipText(type)}</div>}>
              <IconInformation16 />
            </Tooltip>
          </span>
        </a>
        <div className={styles['prices']}>
          <ArticleParagraph2>{`${numberToPrettyString(price)} ₽/мес. за\u00A0рабочее место`}</ArticleParagraph2>
        </div>
        <BookCoworkingModal
          formInitialState={{
            [EBookCoworkingFormFields.CoworkingOfferType]: { errorMessage: null, value: getPlaceModalType(type) },
            [EBookCoworkingFormFields.WorkplaceCount]: { errorMessage: null, value: count.toString() },
          }}
        >
          {modalVisibilityState => (
            <div className={styles['button']}>
              <ButtonWithAnalyticEvent
                analyticsParams={{ gaObjectType: getPlaceGaObjectType(type) }}
                size="XS"
                theme="stroke_secondary"
                trackAnalyticEvent={trackBookingButtonClick}
                type="button"
                onClick={modalVisibilityState.setTrue}
              >
                Забронировать
              </ButtonWithAnalyticEvent>
            </div>
          )}
        </BookCoworkingModal>
      </div>
    </div>
  );
};

Place.displayName = 'Place';
